import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import vadoTheme from '../main/VadoThemeMui5'; // Import VadoTheme for mui 5
import { ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

export default function LocationListDialog(props) {
    const { open, onClose, locations, title, loading } = props;
    const { t } = useTranslation();

    return (
        <ThemeProvider theme={vadoTheme}>
            <Dialog open={!!open} onClose={onClose} aria-labelledby="location-list-dialog-title">
                <DialogTitle
                    id="location-list-dialog-title"
                    sx={{ m: 0, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {title || t('general.locations')}
                    </Typography>
                    <IconButton aria-label="close" onClick={onClose} edge="end">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ minWidth: 360, maxWidth: '80vw', py: 1, px: 2 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
                            <CircularProgress />
                        </Box>
                    ) : Array.isArray(locations) && locations.length > 0 ? (
                        <List sx={{ maxHeight: '50vh', overflow: 'auto' }}>
                            {locations.map((loc) => (
                                <ListItem key={loc.id} sx={{ cursor: 'pointer' }}>
                                    <ListItemText primary={loc.name} secondary={loc.portfolio && loc.portfolio.name} />
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                            {t('customer.noLocations')}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        data-testid="btn-close"
                        size="small"
                        variant="contained"
                        color="secondary"
                        onClick={onClose}>
                        {t('buttons.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

LocationListDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    locations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            name: PropTypes.string,
            address: PropTypes.string,
            city: PropTypes.string,
        })
    ),
    title: PropTypes.string,
    loading: PropTypes.bool,
    // optional callback when a location is selected: onSelect(location)
    onSelect: PropTypes.func,
};
